import { render, staticRenderFns } from "./feedNode.vue?vue&type=template&id=47865d58&scoped=true"
import script from "./feedNode.vue?vue&type=script&lang=js"
export * from "./feedNode.vue?vue&type=script&lang=js"
import style0 from "./feedNode.vue?vue&type=style&index=0&id=47865d58&prod&lang=less"
import style1 from "./feedNode.vue?vue&type=style&index=1&id=47865d58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47865d58",
  null
  
)

export default component.exports